// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const hiddenAnnouncementSelector = createSelector(
    (state): any => state,
    (res: any) => res.hiddenAnnouncement
);
